exports.ENGLISH_TRANSLATE = {
  //! Traduccion etiquetas simples
  DATA_MAINTENANCE: "Data maintenance",
  DATA_MAINTENANCE_TYPES: "Types",
  DATA_MAINTENANCE_HOLDER: "Holders",
  DATA_MAINTENANCE_OTHER: "Other data",
  HOLDERS: "Holders",
  OFFICES: "Offices",
  OFFICE: "Office",
  COUNTRIES: "Countries",
  COUNTRY: "Country",
  CALENDAR: "Agenda",
  LOCATIONS: "Localities",
  TYPES_OF_DOCUMENTS: "Types of documents",
  SAMPLE_TYPES: "Sample types",
  SAMPLE_TYPE: "Sample type",
  MEDICAL_INSTITUTIONS: "Medical institutions",
  MEDICAL_INSTITUTION: "Medical institution",
  CLIENTS: "Clients",
  MEDICAL_SPECIALTIES: "Medical specialties",
  SPECIALTY: "Specialty",
  SPECIALTIES: "Specialties",
  DOCTORS: "Doctors",
  DOCTOR: "Doctor",
  HEADLINES: "Headlines",
  WITNESSES: "Witnesses",
  ETHNIC_ORIGIN: "Ethnic origin",
  INDIVIDUALS: "Individuals",
  STAGE: "Stage",
  STAGES: "Stages",
  TECHNIQUES: "Techniques",
  TECHNIQUE: "Technique",
  KINSHIPS: "Kinships",
  KINSHIP: "Kinship",
  TYPES_OF_CLINICAL_ANALYSIS: "Types of clinical analysis",
  TYPE_OF_CLINICAL_ANALYSIS: "Type of clinical analysis",
  PICK_TYPE_OF_CLINICAL_ANALYSIS: "Select a type of clinical analysis",
  TYPES_OF_PATERNITY_STUDIES: "Types of paternity studies",
  TYPE_OF_PATERNITY_STUDY: "Type of paternity study",
  PICK_TYPE_OF_PATERNITY_STUDY: "Select a type of paternity study",
  PRODUCTS: "Products",
  PRODUCT: "Product",
  GENETIC_MARKERS: "Genetic markers",
  APPOINTMENT_SECTORS: "Appointment sectors",
  APPOINTMENT_SECTOR: "Appointment sector",
  COORDINATION_TYPES: "Coordination types",
  NURSES: "Nurses",
  MARKER: "Genetic marker",
  CLINICAL_ANALYZES: "Clinical analyzes",
  CLINICAL_ANALYSIS: "Clinical analysis",
  CLINICAL_ANALYSIS_DATA: "Clinical analysis data",
  CLINICAL_ANALYSIS_SHEET: "Clinical analysis sheet",
  SHOW_CLINICAL_ANALYSIS: "Open analysis",
  LIST: "List",
  NEW: "New",
  OUTBOX: "Outbox",
  INBOX: "Inbox",
  CREATE_ANALYSIS_FROM_SPREADSHEET: "Create analysis from spreadsheet",
  CREATE_STUDIES_FROM_SPREADSHEET: "Create studies from panilla",
  IMPORT_RESULTS_FROM_SPREADSHEET: "Import results from spreadsheet",
  CREATE_PROSPECTS_FROM_SPREADSHEET: "Create prospect from spreadsheet",
  IMPORT_GENEMAPPER: "Import file - Genemapper",
  PATERNITY_STUDIES: "Paternity studies",
  PATERNITY_STUDY: "Paternity study",
  PATERNITY_STUDY_SHEET: "Paternity study sheet",
  CALCULATE_PATERNITY: "Calculate paternity",
  PROSPECTS: "Prospects",
  PROSPECT: "Prospect",
  SECURITY: "Security",
  TASKS: "Tasks",
  USER: "User",
  USERS: "Users",
  CHANGE_PASSWORD: "Change password",
  PASSWORD_CHANGE: "Change password",
  PASSWORDS_NOT_MATCH: "The key and its repetition do not match",
  ROLES: "Roles",
  TOOLS: "Tools",
  SYSTEM_PARAMS: "System parameters",
  LOGOUT: "Logout of {{value}}",
  NEXT: "Next",
  BACK: "Previous",
  LOGIN: "Login",
  PASSWORD: "Password",
  CONFIRM_PASSWORD: "Confirm password",
  CURRENT_PASSWORD: "Current password",
  NEW_PASSWORD: "New password",
  PASSWORD_SPECIFICATIONS:
    "The password must contain at least one uppercase, one lowercase, a number and some symbol (@, $, !, %, *, ?, &, #)",
  PASSWORD_LENGTH: "The minimum password length is: 8",
  EMAIL: "Email",
  ROLE: "Role",
  EXTRACTION_METHOD: "Extraction method",
  EXTRACTION_METHODS: "Extraction methods",
  ALLELE_1: "Allele 1",
  ALLELE_2: "Allele 2",
  ALLELE_3: "Allele 3",
  PASSWORD_REQUIRED: "Password required",
  CURRENT_PASSWORD_REQUIRED: "Current password required",
  EMAIL_REQUIRED: "Email required",
  NAME_REQUIRED: "Name required",
  COLOR_REQUIRED: "Color required",
  COLOR_CONTRAST_INVALID: "Contrast is not enough",
  SHORT_NAME_REQUIRED: "Short name required",
  LASTNAME_REQUIRED: "Lastname required",
  USERNAME_REQUIRED: "Username required",
  DOCUMENT_TYPE_REQUIRED: "Document type required",
  DOCUMENT_INVALID: "Invalid document",
  DOCUMENT_INVALID_FORMAT: "Invalid document format",
  DOCUMENT_REQUIRED: "Document required",
  PHONE_REQUIRED: "Phone required",
  LOCATION_REQUIRED: "Location required",
  ADDRESS_REQUIRED: "Address required",
  CODE_REQUIRED: "Code required",
  NUMBER_REQUIRED: "Number required",
  SERIE_REQUIRED: "Serie required",
  TITLE_REPORT_REQUIRED: "Title for the report is required",
  DEADLINE_REQUIRED: "The deadline is required",
  DEADLINE_TYPE_REQUIRED: "The type of deadline is required",
  TECHNIQUE_REQUIRED: "The technique is required",
  COORDINATION_TYPE_REQUIRED: "Type of coordination required",
  INDIVIDUAL_REQUIRED: "The individual is required",
  TYPE_OF_CLINICAL_ANALYSIS_SEARCH: "The search is performed on the following fields: name, code and series",
  TYPE_OF_PATERNITY_STUDY_SEARCH: "The search is performed on the following fields: name, code and series",
  INDIVIDUAL_SEARCH_FIELDS: "The search is carried out on the following data: code, names, surnames, number of document, office and country",
  WITNESS_REQUIRED: "The individual is required",
  WITNESS_SEARCH_FIELDS: "The search is carried out on the following data: names, surnames, number of document",
  MEDICAL_INSTITUTION_SEARCH: "Search for medical institutions",
  MEDICAL_INSTITUTION_SEARCH_FIELDS: "The search is carried out on the following data: id, name, address, country, telephone, email",
  DOCTOR_SEARCH: "Doctor Search",
  WITNESS_SEARCH: "Witness search",
  DOCTOR_SEARCH_FIELDS: "The search is carried out on the following data: name, document, telephone, license number, country",
  NURSE_SEARCH: "Nurse Search",
  NURSE_SEARCH_FIELDS: "The search is performed on the following data: name, document",
  SELECT_DOCTOR: "Select a doctor",
  SELECT_MEDICAL_INSTITUTION: "Select a medical institution",
  TYPE_ANALYSIS_CLINICAL_REQUIRED: "Type of clinical analysis required",
  TYPE_PATERNITY_STUDY_REQUIRED: "Type of paternity required",
  MEDICAL_INSTITUTION_REQUIRED: "Medical institution required",
  DOCTOR_REQUIRED: "Doctor required",
  UBICATION_REQUIRED: "Ubication required",
  MAIN_EXTRACTION_REQUIRED: "Main extraction required",
  CLIENT_REQUIRED: "Client required",
  METHOD_REQUIRED: "Method required",
  TACOS_RECEIVED_REQUIRED: "Tacos received required",
  PROCESSED_TACOS_REQUIRED: "Processed tacos required",
  QUANTITY_REQUIRED: "Quantity required",
  CONCENTRATION_REQUIRED: "Concentration required",
  TEAM_REQUIRED: "Team required",
  BOX_REQUIRED: "Box required",
  COLUMN_REQUIRED: "Required column",
  ROW_REQUIRED: "Required row",
  METHODOLOGY_REQUIRED: "A result is required",
  RESULT_REQUIRED: "A methodology is required",
  INTERPRETATION_REQUIRED: "An interpretation is required",
  CONCLUSION_REQUIRED: "A conclusion is required",
  SAMPLE_REQUIRED: "At least one sample is needed",
  SAMPLE_TYPE_REQUIRED: "At least one type of sample is needed",
  OFFICE_REQUIRED: "Required office",
  COMPANY_REQUIRED: "Required company name",
  TRUCKING_NUMBER_REQUIRED: "Required tracking number",
  ETHNIC_ORIGIN_REQUIRED: "Required ethnic origin",
  GENDER_REQUIRED: "Biological sex required",
  TASKS_REQUIRED: "Task(s) required",
  SAP_CODE_REQUIRED: "Sap code required",
  SOCIAL_REASON_REQUIRED: "Social reason required",
  COUNTRY_REQUIRED: "Country required",
  PRICE_REQUIRED: "Price required",
  FORMAT_REQUIRED: "Required format",
  FILE_REQUIRED: "The file is needed to continue",
  DESCRIPTION_REQUIRED: "Description required",
  NURSE_REQUIRED: "Nurse required",
  DATE_REQUIRED: "Date required",
  DATES_REQUIRED: "Required dates",
  SUPPORTED_FILES_NOT_SELECTED: "Supported files were not selected",
  SUPPORTED_FILE_EXTENSION: "Supported file extension/s",
  DETAILS: "Details",
  STUDY_DATA: "Study data",
  EMPTY_DATA: "No data",
  SELECT_DATA: "Select data",
  LOCATION_DATA: "Location data",
  INDIVIDUAL_SEARCH: "Pesquisar pessoas",
  CREATE_NEW_INDIVIDUAL: "Create new individual",
  SELECTION_OF_INDIVIDUALS: "Selection of individuals",
  SAMPLE_INPUT: "Sample input",
  EMPTY_OBSERVATIONS: "No observations",
  EMPTY_INDIVIDUAL: "No individual",
  ALL_DATA: "All",
  SAVE: "Save",
  ACCEPT: "Accept",
  CANCEL: "Cancel",
  CLOSE: "Close",
  FIRST_NAME: "First name",
  SECOND_NAME: "Second name",
  FIRST_LASTNAME: "First lastname",
  SECOND_LASTNAME: "Second lastname",
  BIRTH_DATE: "Birth date",
  REGISTRATION_DATE: "Registration date",
  ENTER: "Enter",
  EMPTY_DETAILS: "No details",
  CLEAN: "Clean up",
  CLEAN_SECTION: "Clean section",
  CLEAN_FILTERS: "Clean filters",
  SEARCH: "Search",
  AUTOCOMPLETE: "Autocomplete",
  TYPE: "Type",
  CONFIRMATION: "Confirmation",
  CONFIRM_ACTION: "Do you want to confirm this action",
  YES: "Yes",
  NO: "No",
  SERIE: "Serie",
  NUMBER: "Number",
  COPY_NUMBER: "Copy number",
  COPY_DATE: "Date of admission",
  COPY_NUMBER_SMALL: "Nº copy",
  COPY: "Copy",
  COPY_NAME: "Copy",
  RELATIONSHIP: "Relationship",
  DELETE: "Delete",
  EDIT: "Edit",
  DATE: "Date",
  HOUR: "Hour",
  START_TIME: "Start time",
  END_TIME: "End time",
  START_TIME_REQUIRED: "Start time required",
  END_TIME_REQUIRED: "End time required",
  CODE: "Code",
  ORIGIN_CODE: "Origin code",
  DM_CODE: "DM Code of Practice",
  LOT: "Lot",
  LOT_MAX_LENGTH: "The lot must have {{ max_length }} characters maximum",
  STATUS: "Status",
  STATUS_ACTIVE: "This record is active, so it will appear in future searches",
  STATUS_INACTIVE:
    "This record is inactive, so it will NOT appear in future searches",
  SHOW: "Show",
  IS_FINAL: "Is final",
  STAGE_IS_FINAL_REQUIRED: "You must mark at least one stage as final",
  SELECT: "Select",
  DOWNLOAD: "Download",
  CHANGE_CLIENT: "Change client",
  TITLE_REPORT: "Title for the report",
  DEADLINE: "Deadline",
  DAYS: "{{value}} day/s",
  DEADLINE_TYPE: "Deadline type",
  METHODOLOGIES: "Methodologies",
  METHODOLOGY: "Methodology",
  INTERPRETATION: "Interpretation",
  CONCLUSION: "Conclusion",
  RESULTS: "Results",
  RESULT: "Result",
  ADD_RESULT: "Add result",
  DEADLINE_TYPE_NORMAL: "Normal days",
  DEADLINE_TYPE_BUSSINESS: "Business days",
  DEADLINE_TYPE_OTHER: "Other",
  DESCRIPTION: "Description",
  PROCESSED_TACOS: "Processed tacos",
  TACOS_RECEIVED: "Tacos received",
  QUANTITY: "Quantity",
  MICROLITERS: "Microliters",
  CONCENTRATION: "Concentration",
  NANOGRAM_PER_MICROLITER: "Nanogram per microliter",
  DEVOLUTION_DATE: "Return date",
  METHOD: "Method",
  //! Nuevo estudio de paternidad
  TYPE_OF_STUDY: "Type of study",
  DATE_OF_ADMISSION: "Date of admission",
  ADMISSION: "Admission",
  FROM: "From",
  TO: "To",
  CLIENT: "Client",
  NURSE: "Nurse",
  RECORDS: "Records",
  RECIPIENTS: "Recipients",
  RECIPIENTS_EMPTY: "No recipients",
  NEW_CLIENT: "New client",
  SELECT_CLIENT: "Select a client",
  CLEAR_SELECTION: "Clear selection",
  CLIENT_SEARCH: "Client search",
  CLIENT_SEARCH_FIELDS: "The search is carried out on the following data: id, name, business name, document, SAP code and country",
  CREATE_NEW_CLIENT: "Create new client",
  NAME: "Name",
  ORDER: "Order",
  COLOR: "Color",
  SHORT_NAME: "Short name",
  GM_NAME: "GM Name",
  FORMAT: "Format",
  LASTNAME: "Lastname",
  USERNAME: "Username",
  SOCIAL_REASON: "Social reason",
  SAP_CODE: "SAP code",
  CURRENCY: "Currency",
  PRICE: "Price",
  DOLLAR: "Dollar",
  LOCAL_CURRENCY: "Local currency",
  DOCUMENT_TYPE: "Document type",
  DOCUMENT: "Document",
  PROFESSIONAL_LICENSE: "Professional license",
  PHONE: "Phone",
  ADDRESS: "Address",
  DEVOLUTION_ADDRESS: "Devolution address",
  LOCATION: "Location",
  UBICATION: "Ubication",
  TEAM: "Team",
  BOX: "Box",
  ROW: "Row",
  COLUMN: "Column",
  ORIGIN: "Origin",
  MAIN_EXTRACTION: "Main extraction",
  VALUE: "Value",
  INDIVIDUAL_INFORMATION: "Individual information",
  NURSE_INFORMATION: "Nurse information",
  CONTACT_INFORMATION: "Contact information",
  YOU_CONTACT_INFORMATION: "Contact information",
  CLIENT_INFORMATION: "Client information",
  COMPLETE_INFORMATION: "Complete information",
  ASSIGN_PROFILES: "Profile assignment to individuals",
  IMPORT_PROFILES: "Import profiles",
  CONTACT_NAME: "Contact name",
  CONTACT_PHONE: "Contact phone",
  CONTACT_EMAIL: "Contact email",
  OBSERVATION: "Observation",
  OBSERVATIONS: "Observations",
  OFFICE_DATA: "Office data",
  STAGE_DATA: "Stage data",
  TECHNIQUE_DATA: "Technique data",
  TYPE_OF_CLINICAL_ANALYSIS_DATA: "Data of the type of clinical analysis",
  TYPE_OF_PATERNITY_STUDY_DATA: "Paternity study type data",
  POSTAL_CODE: "Postal code",
  ENTER_INDIVIDUALS_FROM_THE_BOTTOM: "Enter individuals from the bottom",
  ADD_INDIVIDUALS: "Add individuals",
  ADD_INDIVIDUAL: "Add individual",
  INDIVIDUAL: "Individual",
  INSTITUTION: "Institution",
  NEW_INDIVIDUAL: "New individual",
  GENDER: "Biological sex",
  GENDERS: "Biological sex",
  COORDINATION_TYPE: "Coordination type",
  TASK_NAME: "Task name",
  ADD_TRACE: "Add trace",
  ADD_SAMPLE: "Add sample",
  ADD_SAMPLES: "Add samples",
  SAMPLE_DATA: "Sample data",
  EXTRACTION_DATE: "Extraction date",
  TYPE_OF_SAMPLE: "Type of sample",
  EXTRACTIONIST: "Extractionist",
  EXTRACTIONIST_DATA: "Extractionist data",
  EXTRACTIONIST_NAME: "Extractionist name",
  EXTRACTIONIST_DOCUMENT: "Extractionist document",
  EXTRACTIONIST_DOCUMENT_TYPE: "Extractionist document type",
  WITHOUT_EXTRACTIONIST: "No associated extractionist",
  WITNESS_DATA: "Witness data",
  USER_DATA: "User data",
  ROLE_DATA: "Role data",
  GENDER_DATA: "Biological sex data",
  APPOINTMENT_SECTOR_DATA: "Appointment sector data",
  COORDINATION_TYPE_DATA: "Coordination type data",
  SPECIALTY_DATA: "Specialty data",
  DOCTOR_DATA: "Doctor data",
  COUNTRY_DATA: "Country data",
  KINSHIP_DATA: "Kinship data",
  MEDICAL_INSTITUTION_DATA: "Medical institution data",
  PRODUCT_DATA: "Product data",
  SAMPLE_TYPE_DATA: "Sample type data",
  DOCUMENT_TYPE_DATA: "Document type data",
  MARKER_DATA: "Marker data",
  ETHNIC_ORIGIN_DATA: "Ethnic origin data",
  PROSPECT_DATA: "Prospect data",
  EXTRACTION_METHOD_DATA: "Extraction method data",
  NEW_APPOINTMENT_SECTOR: "New appointment sector",
  NEW_WITNESS: "New witness",
  NEW_OFFICE: "New office",
  NEW_STAGE: "New stage",
  NEW_TECHNIQUE: "New technique",
  NEW_TYPE_ANALYSIS_CLINICAL: "New type of clinical analysis",
  NEW_USER: "New user",
  NEW_PATERNITY_STUDIE: "New paternity study",
  NEW_CLINICAL_ANALYSIS: "New clinical analysis",
  NEW_ROLE: "New rol",
  NEW_LOCATION: "New location",
  NEW_GENDER: "New biological sex",
  NEW_NURSE: "New nurse",
  NEW_COORDINATION_TYPE: "New coordination type",
  NEW_SPECIALTY: "New specialty",
  NEW_DOCTOR: "New doctor",
  NEW_COUNTRY: "New country",
  NEW_KINSHIP: "New kinship",
  NEW_MEDICAL_INSTITUTION: "New medical institution",
  NEW_ETHNIC_ORIGIN: "New ethnic origin",
  NEW_PRODUCT: "New product",
  NEW_TYPE_PATERNITY_STUDY: "New kind of paternity study",
  NEW_SAMPLE_TYPE: "New sample type",
  NEW_DOCUMENT_TYPE: "New document type",
  NEW_MARKER: "New marker",
  NEW_PROSPECT: "New prospect",
  NEW_EXTRACTION_METHOD: "New method",
  WITNESS: "Witness",
  WITNESS_NAME: "Witness name",
  WITNESS_LASTNAME: "Witness lastname",
  WITNESS_DOCUMENT: "Witness document",
  WITNESS_EMAIL: "Witness email",
  WITNESS_ADDRESS: "Witness address",
  WITNESS_PHONE: "Witness phone",
  WITHOUT_WITNESS: "No associated witness",
  THE_SAMPLES_ENTERED_WILL_BE_DISPLAYED_HARA:
    "The samples entered will be displayed here",
  YOU_MUST_SELECT_AT_LEAST_TWO_INDIVIDUALS:
    "You must select at least two individuals",
  ALL_INDIVIDUALS_MUST_HAVE_AN_ASSOCIATED_RELATIONSHIP:
    "All individuals must have an associated relationship",
  THERE_MUST_BE_TWO_DIFFERENT_TYPES_OF_RELATIONSHIPS:
    "There must be two different types of relationships",
  THE_INDIVIDUAL_MUST_HAVE_A_FIRST_NAME:
    "The individual must have a first name",
  THE_INDIVIDUAL_MUST_HAVE_A_FIRST_LASTNAME:
    "The individual must have a first lastname",
  THE_INDIVIDUAL_MUST_HAVE_A_TYPE_OF_DOCUMENT:
    "The individual must have a type of document",
  THE_INDIVIDUAL_MUST_HAVE_A_DOCUMENT: "The individual must have a document",
  THE_INDIVIDUAL_MUST_HAVE_A_GENDER: "The individual must have a biological sex",
  THE_INDIVIDUAL_MUST_HAVE_A_ETHNIC_ORIGIN:
    "The individual must have a ethnic origin",
  THE_INDIVIDUAL_MUST_HAVE_A_ADDRESS: "The individual must have a address",
  THE_INDIVIDUAL_MUST_HAVE_A_LOCATION: "The individual must have a location",
  THERE_IS_ALREADY_AN_INDIVIDUAL_WITH_THAT_DOCUMENT:
    "There is already an individual with that document",
  SELECT_A_WITNESS_OR_ENTER_A_NEW_ONE: "Select a witness or enter a new one",
  ENTER_A_MEANS_OF_CONTACT_FOR_THE_WITNESS:
    "Enter a means of contact for the witness",
  ENTER_THE_WITNESS_DOCUMENT: "Enter the witness document",
  ENTER_THE_WITNESS_LOCATION: "Enter the witness location",
  ENTER_THE_WITNESS_ADDRESS: "Enter the witness address",
  SELECT_A_DOCUMENT_TYPE_FOR_THE_WITNESS:
    "Select a document type for the witness",
  ENTER_THE_LAST_NAME_OF_THE_WITNESS: "Enter the last name of the witness",
  ENTER_THE_NAME_OF_THE_WITNESS: "Enter the name of the witness",
  ENTER_THE_EXTRACTIONIST_DOCUMENT: `Enter the extractionist's document`,
  ENTER_THE_TYPE_OF_DOCUMENT_OF_THE_EXTRACTIONIST:
    "Enter the type of document of the extractionist",
  ENTER_THE_NAME_OF_THE_EXTRACTIONIST: "Enter the name of the extractionist",
  PICK_AN_INDIVIDUAL: "Pick an individual",
  PICK_NURSE: "Pick a nurse",
  CHOOSE_A_SAMPLE_TYPE: "Choose a sample type",
  SAMPLE_COORDINATION: "Sample collection coordination",
  SAMPLE_TYPE_ALREADY_EXISTS: "A sample type with that name already exists",

  PATERNITY_STUDIES_LIST_EMPTY:
    "At the moment we do not have any registered paternity study",
  CLINICAL_ANALYSIS_LIST_EMPTY:
    "At the moment we do not have any registered analysis",
  PATERNITY_STUDIES_LIST_INBOX_EMPTY:
    "At the moment there are no paternity studies sent to your office",
  PATERNITY_STUDIES_LIST_OUTBOX_EMPTY:
    "At the moment your office has not sent any paternity studies to another office",
  CLINICAL_ANALYSIS_LIST_INBOX_EMPTY:
    "At the moment there are no clinical analyzes sent to your office",
  CLINICAL_ANALYSIS_LIST_OUTBOX_EMPTY:
    "At this time your office has not sent any clinical analysis to another office",
  WITNESS_LIST_EMPTY: "At the moment we do not have any registered witnesses",
  OFFICES_LIST_EMPTY: "At the moment we do not have any registered office",
  STAGES_LIST_EMPTY: "At the moment we do not have any registered stage",
  TECHNIQUES_LIST_EMPTY:
    "At the moment we do not have any registered technique",
  TYPES_ANALYSIS_CLINICAL_LIST_EMPTY:
    "At the moment we do not have any type of clinical analysis registered",
  INDIVIDUALS_LIST_EMPTY:
    "At the moment we do not have any registered individuals",
  CLINICAL_ANALYSIS_LIST_EMPTY_INDIVIDUAL:
    "At the moment we do not have any clinical analysis associated with this individual",
  SPECIALTIES_LIST_EMPTY_DOCTOR:
    "At the moment the doctor does not have any medical specialty",
  USERS_LIST_EMPTY: "For the moment we have no registered user",
  METHODOLOGIES_LIST_EMPTY: "No methodologies assigned",
  RESULTS_LIST_EMPTY: "No results assigned",
  ROLES_LIST_EMPTY: "At the moment we do not have any registered role",
  USER_OFFICES_LIST_EMPTY: "No assigned offices",
  CLIENTS_LIST_EMPTY: "At the moment we do not have any registered client",
  LOCATIONS_LIST_EMPTY: "At the moment we do not have any registered location",
  GENDERS_LIST_EMPTY: "At the moment we do not have any registered biological sex",
  APPOINTMENT_SECTOR_LIST_EMPTY:
    "At the moment we do not have any registered sector",
  COORDINATION_TYPES_LIST_EMPTY:
    "At the moment we do not have any registered type",
  SPECIALTIES_LIST_EMPTY:
    "At the moment we do not have any registered specialty",
  DOCTORS_LIST_EMPTY: "At the moment we do not have a registered doctor",
  NURSES_LIST_EMPTY: "At the moment we do not have a registered nurse",
  COUNTRIES_LIST_EMPTY: "At the moment we do not have any registered country",
  KINSHIPS_LIST_EMPTY:
    "At the moment we do not have any registered relationship",
  MEDICAL_INSTITUTIONS_LIST_EMPTY:
    "At the moment we do not have any registered medical institution",
  PRODUCTS_LIST_EMPTY: "At the moment we do not have any registered products",
  TYPES_PATERNITY_STUDY_LIST_EMPTY:
    "At the moment we do not have any type of registered paternity study",
  ETHNIC_ORIGINS_LIST_EMPTY:
    "At the moment we do not have any registered ethnic origin",
  SAMPLE_TYPES_LIST_EMPTY:
    "At the moment we do not have any type of sample registered",
  MARKERS_LIST_EMPTY:
    "At the moment we do not have any registered genetic markers",
  DOCUMENT_TYPES_LIST_EMPTY:
    "At the moment we do not have any type of document registered",
  TASKS_LIST_EMPTY: "At the moment we do not have tasks in the system",
  PROSPECTS_LIST_EMPTY: "At the moment we do not have registered prospects",
  EXTRACTION_METHODS_LIST_EMPTY:
    "At the moment we do not have extraction methods registered",
  SYSTEM_PARAMS_LIST_EMPTY:
    "At the moment we do not have registered parameters",
  INDIVIDUALS_LIST_EMPTY_WITH_FILTERS: "No individuals found with that filter",
  PATERNITY_STUDIES_LIST_EMPTY_WITH_FILTERS:
    "No paternity studies were found with that filter",
  CLINICAL_ANALYSIS_LIST_EMPTY_WITH_FILTERS: "No analysis found that filter",
  WITNESS_LIST_EMPTY_WITH_FILTERS: "No witnesses were found with that filter",
  OFFICES_LIST_EMPTY_WITH_FILTERS: "No offices were found with that filter",
  STAGES_LIST_EMPTY_WITH_FILTERS: "No stages were found with that filter",
  TECHNIQUES_LIST_EMPTY_WITH_FILTERS:
    "No techniques were found with that filter",
  TYPES_ANALYSIS_CLINICAL_LIST_EMPTY_WITH_FILTERS:
    "No clinical analysis types found with that filter",
  USERS_LIST_EMPTY_WITH_FILTERS: "No users were found with that filter",
  ROLES_LIST_EMPTY_WITH_FILTERS: "No roles were found with that filter",
  CLIENTS_LIST_EMPTY_WITH_FILTERS: "No clients were found with that filter",
  LOCATIONS_LIST_EMPTY_WITH_FILTERS: "No locations were found with that filter",
  GENDERS_LIST_EMPTY_WITH_FILTERS: "No biological sexs found with that filter",
  APPOINTMENT_SECTORS_LIST_EMPTY_WITH_FILTERS:
    "No sectors found with that filter",
  COORDINATION_TYPES_LIST_EMPTY_WITH_FILTERS: "No types found with that filter",
  SPECIALTIES_LIST_EMPTY_WITH_FILTERS: "No specialties found with that filter",
  DOCTORS_LIST_EMPTY_WITH_FILTERS: "No doctors found with that filter",
  NURSES_LIST_EMPTY_WITH_FILTERS: "No nurses found with that filter",
  COUNTRIES_LIST_EMPTY_WITH_FILTERS: "No countries with that filter found",
  KINSHIPS_LIST_EMPTY_WITH_FILTERS: "No relationships found with that filter",
  MEDICAL_INSTITUTIONS_LIST_EMPTY_WITH_FILTERS:
    "No medical institutions found with that filter",
  PRODUCTS_LIST_EMPTY_WITH_FILTERS: "No products were found with that filter",
  TYPES_PATERNITY_STUDY_LIST_EMPTY_WITH_FILTERS:
    "No paternity study types found with that filter",
  ETHNIC_ORIGINS_LIST_EMPTY_WITH_FILTERS:
    "No ethnic origin found with that filter",
  SAMPLE_TYPES_LIST_EMPTY_WITH_FILTERS:
    "No sample types found with that filter",
  DOCUMENT_TYPES_LIST_EMPTY_WITH_FILTERS:
    "No document types found with that filter",
  MARKERS_LIST_EMPTY_WITH_FILTERS: "No genetic markers found with that filter",
  TASKS_LIST_EMPTY_WITH_FILTERS: "No tasks found with that filter",
  PROSPECTS_LIST_EMPTY_WITH_FILTERS: "No leads found with that filter",
  EXTRACTION_METHODS_LIST_EMPTY_WITH_FILTERS:
    "No extraction methods found with that filter",
  SYSTEM_PARAMS_LIST_EMPTY_WITH_FILTERS: "No parameters found with that filter",
  TRANSPORT_EMPTY: "Currently this clinical analysis is not in transport",
  ADVANCED_FILTERS: "Advanced filters",
  CURRENT_STAGE: "Current stage",
  GROUP_TASKS: "Group tasks",
  SAMPLING_VISITS: "Sample taking visits",
  SELECTED_STUDIES: "Selected studies",
  SELECTED_ANALYZES: "Selected analyzes",
  SELECTED_PROSPECTS: "Selected prospects",
  FILTER_STUDIES: "Filter studies",
  FILTER_ANALYZES: "Filter analyzes",
  FILTER_WITNESSES: "Filter witnesses",
  FILTER_OFFICES: "Filter offices",
  FILTER_STAGES: "Filter stages",
  FILTER_TECHNIQUES: "Filter techniques",
  FILTER_TYPES_ANALYSIS_CLINICAL: "Filter types of clinical analysis",
  FILTER_INDIVIDUALS: "Filter individuals",
  FILTER_USERS: "Filter users",
  FILTER_ROLES: "Filter roles",
  FILTER_CLIENTS: "Filter clients",
  FILTER_LOCATIONS: "Filter locations",
  FILTER_GENDERS: "Filter biological sexs",
  FILTER_COORDINATION_TYPES: "Filter coordination types",
  FILTER_SPECIALTIES: "Filter specialties",
  FILTER_DOCTORS: "Filter doctors",
  FILTER_NURSES: "Filter nurses",
  FILTER_COUNTRIES: "Filter countries",
  FILTER_KINSHIP: "Filter kinships",
  FILTER_MEDICAL_INSTITUTIONS: "Filter medical institutions",
  FILTER_ETHNIC_ORIGINS: "Filter ethnic origins",
  FILTER_PRODUCTS: "Filter products",
  FILTER_TYPES_PATERNITY_STUDY: "Filter types of paternity studies",
  FILTER_SAMPLE_TYPES: "Filter sample types",
  FILTER_DOCUMENT_TYPES: "Filter document types",
  FILTER_MARKERS: "Filter markers",
  FILTER_TASKS: "Filter tasks",
  FILTER_PROSPECTS: "Filter prospects",
  FILTER_EXTRACTION_METHODS: "Filter methods",
  FILTER_SYSTEM_PARAMS: "Filter parameters",
  FILTER_APPOINTMENT_SECTOR: "Filter sectors",
  STUDY_CODE: "Study code",
  STUDY_NUMBER: "Study number",
  SITUATION: "Situation",
  STATE: "State",
  PROMISED_DELIVERY: "Promised Delivery",
  TECHNIQUE_SELECTED: "Selected technique",
  STUDY_TYPE_SELECTED: "Type of study selected",

  SELECT_INDIVIDUAL: "Select an individual",
  SELECT_RELATIONSHIP: "Select an relationship",
  SELECT_SAMPLE_TYPE: "Select a sample type",
  SELECT_WITNESS: "Select a witness",
  SELECT_STAGE: "Select a stage",
  SELECT_STAGES: "Select one or more stages",
  SELECT_TASK: "Select task",
  SELECT_ALL_PAGE: "Select entire page",
  ENTER_DETAIL: "Enter a detail",
  ENTER_OBSERVATION_TRACEABILITY: "Enter an observation to the trace",
  OBSERVATION_TRACEABILITY_MAX_LENGTH: "The comment must have a maximum of {{ max_length }} characters",
  STUDY: "Study",
  SAMPLES: "Samples",
  TRANSPORT: "Transport",
  TRACEABILITY: "Traceability",
  ATTACHMENTS: "Attachments",
  ATTACH_FILES: "Attach files",
  PICTURE: "Picture",
  FOOTPRINT: "Footprint {{value}}",
  SEND_OTHER_OFFICE: "Send to another office",
  GENERATE_REPORTS: "Generte Reports",
  EXPORT_REPORTS: "Export List",
  SEND: "Send",
  PROCESS: "Process",
  CHECK_VISITS: "Check visits summary",
  TAKE_VISITS_REPORT: "Take visit report",
  CHANGE_STAGE: "Change stage",
  CREATE_PATERNITY_OR_ANALYZES: "Create analysis or paternity",
  CHANGE_STAGE_MESSAGE_PATERNITY_STUDIES:
    "Paternity studies will change your stage to",
  CHANGE_STAGE_MESSAGE_CLINICAL_ANALYSIS:
    "The clinical analyzes will change their stage to",
  CHANGE_STAGE_MESSAGE_PROSPECTS: "Prospects will change their stage to",
  CHANGE_CREATE_ANALYZES_OR_STUDIES_PROSPECTS:
    "Are you sure you want to create analyzes or paternities",
  CHANGE_CREATE_ANALYZES_OR_STUDIES_PROSPECTS_MESSAGE:
    "A paternity study or clinical analysis will be created for each selected prospect",
  PRINT_LABELS: "Print labels",
  PRINTER: "Printer",
  FINISH_STUDIES: "Finish studies",
  FINISH_ANALYZES: "Finish analyzes",
  RECEIVE_SAMPLES: "Receive samples",
  SELECT_STAGE_GROUP_TASK: "Select the stage to be associated with the studies",
  SELECT_STAGE_GROUP_TASK_MESSAGE: "You must select a stage",
  SELECT_OFFICE_GROUP_TASK: "Select the destination office",
  SELECT_SHIPPING_DETAILS_GROUP_TASK: "Select shipping details",
  SELECT_OFFICES: "Select office(s)",
  SELECT_OFFICE: "Select office",
  SELECT_ROLE: "Select rol",
  SELECT_SPECIALTY: "Select specialty",
  SELECT_SPECIALTIES: "Select specialty(s)",
  SHIPPING_COMPANY_NAME: "Shipping company name",
  TRACKING_NUMBER: "Tracking number",
  //! Mensajes
  YOU_MUST_FILL_IN_ALL_FIELDS: "You must fill in all fields",
  CONFIRM_DELETE_PATERNITY_STUDY:
    "Are you sure you want to delete the paternity study",
  CONFIRM_DELETE_PATERNITY_STUDY_MESSAGE:
    "Please note that you will not see the paternity study on the system again, but we will keep a copy of your data",
  CONFIRM_DELETE_CLINICAL_ANALYSIS:
    "Are you sure you want to delete the clinical analysis",
  CONFIRM_DELETE_CLINICAL_ANALYSIS_MESSAGE:
    "Please note that you will not see the analysis on the system again, but we will keep a copy of your data",
  CONFIRM_DELETE_INDIVIDUAL_FROM_PATERNITY_STUDY:
    "Are you sure you want to eliminate the individual",
  CONFIRM_DELETE_INDIVIDUAL_FROM_PATERNITY_STUDY_MESSAGE:
    "If the individual maintains associated samples, they will also be removed from the paternity study",
  CONFIRM_DELETE_SAMPLE: "Are you sure you want to delete the sample",
  CONFIRM_DELETE_SAMPLE_MESSAGE:
    "The paternity study sample will be completely removed",
  CONFIRM_DELETE_SAMPLE_CLINICAL_MESSAGE:
    "The clinical analysis sample will be completely removed",
  CONFIRM_DELETE_TRACEABILITY: "Are you sure you want to delete the trace",
  CONFIRM_DELETE_TRACEABILITY_MESSAGE:
    "The trace of the paternity study will be removed",
  CONFIRM_DELETE_TRACEABILITY_CLINICAL_MESSAGE:
    "The trace of the clinical analysis will be removed",
  CONFIRM_DELETE_TRACEABILITY_PROSPECT:
    "The trace of the prospect will be removed",
  CONFIRM_DELETE_ATTACHMENT: "Are you sure you want to delete the attachment",
  CONFIRM_DELETE_ATTACHMENT_MESSAGE:
    "The attachment of the paternity study will be removed",
  CONFIRM_DELETE_ATTACHMENT_CLINICAL_MESSAGE:
    "The attachment of the clinical analysis will be removed",
  CONFIRM_DELETE_WITNESS: "Are you sure you want to delete the witness",
  CONFIRM_DELETE_WITNESS_MESSAGE:
    "Please note that you will not see the witness again, but we will keep a copy of your data",
  CONFIRM_DELETE_OFFICE: "Are you sure you want to delete the office",
  CONFIRM_DELETE_OFFICE_MESSAGE:
    "Please note that you will not see the office again, but we will keep a copy of your data",
  CONFIRM_DELETE_STAGE: "Are you sure you want to delete the stage",
  CONFIRM_DELETE_STAGE_MESSAGE:
    "Please note that you will not see the stage again, but we will keep a copy of your data",
  CONFIRM_DELETE_TECHNIQUE: "Are you sure you want to remove the technique",
  CONFIRM_DELETE_TECHNIQUE_MESSAGE:
    "Please note that you will not see the technique again, but we will save a copy of your data",
  CONFIRM_FINALIZE_STUDIES: "Are you sure you want to finish your studies",
  CONFIRM_FINALIZE_STUDIES_MESSAGE:
    "A total of {{value}} paternity studies will be completed",
  CONFIRM_FINALIZE_ANALYZES:
    "Are you sure you want to end the clinical analysis",
  CONFIRM_FINALIZE_ANALYZES_MESSAGE:
    "A total of {{value}} clinical analysis will be completed",
  CONFIRM_SEND_STUDIES_TO_OFFICE: "Are you sure you want to send these studies",
  CONFIRM_SEND_STUDIES_TO_OFFICE_MESSAGE:
    "A total of {{value}} paternity studies will be sent to the office {{name}}",
  CONFIRM_SEND_ANALYZES_TO_OFFICE:
    "Are you sure you want to submit these analyzes",
  CONFIRM_SEND_ANALYZES_TO_OFFICE_MESSAGE:
    "A total of {{value}} clinical analyzes will be sent to the office {{name}}",
  CONFIRM_SEND_ANALYSIS_TO_OFFICE:
    "Are you sure you want to submit this analysis",
  CONFIRM_SEND_ANALYSIS_TO_OFFICE_MESSAGE:
    "The analysis will be sent to another office",
  CONFIRM_RECEIVE_STUDIES: "Are you sure you want to accept these studies",
  CONFIRM_RECEIVE_STUDIES_MESSAGE:
    "A total of {{value}} paternity studies will be assigned to your office",
  CONFIRM_RECEIVE_ANALYZES: "Are you sure you want to accept these analyzes",
  CONFIRM_RESULTS_ANALYZES: "Are you sure you confirm these results",
  CONFIRM_IMPORT_ANALYZES:
    "Are you sure to confirm these new clinical analysis/s",
  CONFIRM_IMPORT_GENETIC_PROFILES:
    "Are you sure to confirm these new genetic profiles",
  CONFIRM_IMPORT_PROSPECTS: "Are you sure to confirm these new prospects",
  CONFIRM_RECEIVE_ANALYZES_MESSAGE:
    "A total of {{value}} clinical tests will be assigned to your office",
  CONFIRM_DELETE_TYPES_ANALYSIS_CLINICAL:
    "Are you sure you want to delete the clinical analysis type",
  CONFIRM_DELETE_TYPES_ANALYSIS_CLINICAL_MESSAGE:
    "Please note that you will not see the type of clinical analysis again, but we will keep a copy of your data",
  CONFIRM_DELETE_INDIVIDUAL: "Are you sure you want to delete the individual",
  CONFIRM_DELETE_INDIVIDUAL_MESSAGE:
    "Please note that you will not see your log in the system again, but we will save a copy of your data",
  CONFIRM_DELETE_USER: "Are you sure you want to delete the user",
  CONFIRM_DELETE_USER_MESSAGE:
    "Keep in mind that this user will not be able to re-enter the system, even so the data that has been modified by him will not be eliminated and will continue to be associated with his account",
  CONFIRM_DELETE_NURSE: "Are you sure you want to delete the nurse",
  CONFIRM_DELETE_NURSE_MESSAGE:
    "Keep in mind that this nurse will not be able to re-enter the system, even so the data that has been modified by him will not be deleted and will continue to be associated with your account.",
  CONFIRM_DELETE_ROLE: "Are you sure you want to delete the role",
  CONFIRM_DELETE_ROLE_MESSAGE:
    "Please note that you will no longer see this role in the system, but we will keep a copy of your data",
  CONFIRM_DELETE_CLIENT: "Are you sure you want to delete the client",
  CONFIRM_DELETE_CLIENT_MESSAGE:
    "Please note that you will no longer see this client in the system, but we will save a copy of your data",
  CONFIRM_DELETE_LOCATION: "Are you sure you want to delete the location",
  CONFIRM_DELETE_LOCATION_MESSAGE:
    "Please note that you will no longer see this location in the system, but we will save a copy of your data",
  CONFIRM_DELETE_GENDER: "Are you sure you want to delete the biological sex",
  CONFIRM_DELETE_GENDER_MESSAGE:
    "Please note that you will no longer see this biological sex in the system, but we will save a copy of your data",
  CONFIRM_DELETE_APPOINTMENT_SECTOR:
    "Are you sure you want to delete the sector",
  CONFIRM_DELETE_APPOINTMENT_SECTOR_MESSAGE:
    "Please note that you will no longer see this sector in the system, but we will save a copy of your data",
  CONFIRM_DELETE_COORDINATION_TYPE:
    "Are you sure you want to delete the coordination type",
  CONFIRM_DELETE_COORDINATION_TYPE_MESSAGE:
    "Please note that you will no longer see this type in the system, but we will save a copy of your data",
  CONFIRM_DELETE_SPECIALTY: "Are you sure you want to delete the specialty",
  CONFIRM_DELETE_SPECIALTY_MESSAGE:
    "Please note that you will no longer see this specialty in the system, but we will save a copy of your data",
  CONFIRM_DELETE_DOCTOR: "Are you sure you want to delete the doctor",
  CONFIRM_DELETE_DOCTOR_MESSAGE:
    "Please note that you will no longer see the doctor in the system, but we will save a copy of his data",
  CONFIRM_DELETE_COUNTRY: "Are you sure you want to delete the country",
  CONFIRM_DELETE_COUNTRY_MESSAGE:
    "Please note that you will no longer see the country in the system, but we will save a copy of your data",
  CONFIRM_DELETE_KINSHIP: "Are you sure you want to delete the kinship",
  CONFIRM_DELETE_KINSHIP_MESSAGE:
    "Please note that you will not see this relationship in the system, but we will keep a copy of your data",
  CONFIRM_DELETE_MEDICAL_INSTITUTION:
    "Are you sure you want to delete the medical institution",
  CONFIRM_DELETE_MEDICAL_INSTITUTION_MESSAGE:
    "Please note that you will no longer see this institution in the system, but we will save a copy of your data",
  CONFIRM_DELETE_PRODUCT: "Are you sure you want to delete the product",
  CONFIRM_DELETE_PRODUCT_MESSAGE:
    "Please note that you will no longer see this product in the system, but we will save a copy of your data",
  CONFIRM_DELETE_TYPES_PATERNITY_STUDY:
    "Are you sure you want to delete the paternity study type",
  CONFIRM_DELETE_TYPES_PATERNITY_STUDY_MESSAGE:
    "Please note that you will not see the technique again, but we will save a copy of your data",
  CONFIRM_DELETE_ETHNIC_ORIGIN: "Are you sure you want to remove ethnicity",
  CONFIRM_DELETE_ETHNIC_ORIGIN_MESSAGE:
    "Please note that you will no longer see this ethnicity in the system, but we will save a copy of your data",
  CONFIRM_DELETE_SAMPLE_TYPE: "Sure you want to delete the sample type",
  CONFIRM_DELETE_SAMPLE_TYPE_MESSAGE:
    "Please note that you will no longer see this type of sample in the system, but we will save a copy of your data",
  CONFIRM_DELETE_DOCUMENT_TYPE: "you sure you want to delete the document type",
  CONFIRM_DELETE_DOCUMENT_TYPE_MESSAGE:
    "Please note that you will no longer see this type of document on the system, but we will save a copy of your data",
  CONFIRM_DELETE_MARKER: "Sure you want to delete the genetic marker",
  CONFIRM_DELETE_MARKER_MESSAGE:
    "Please note that you will no longer see this genetic marker on the system, but we will save a copy of your data",
  CONFIRM_DELETE_PROSPECT: "You sure want to delete the prospect",
  CONFIRM_DELETE_PROSPECT_MESSAGE:
    "Please note that you will no longer see this prospect in the system, but we will save a copy of your data",
  CONFIRM_DELETE_EXTRACTION_METHOD:
    "Sure you want to remove the extraction method",
  CONFIRM_DELETE_EXTRACTION_METHOD_MESSAGE:
    "Please note that you will no longer see this extraction method on the system, but we will save a copy of your data",

  CONFIRM_PASSWORD_CHANGE: "Do you want to confirm the password change",
  CONFIRM_PASSWORD_CHANGE_MESSAGE:
    "The user's password will be changed and their assignment will be closed, so they will have to log in again",

  SELECT_OFFICE_MESSAGE:
    "Select the office to which you want to associate the data",

  GENERAL_SCHEDULER_PAGE_TITLE: "Welcome",
  SCHEDULER_VIEW_TYPE_DAY: "Day",
  SCHEDULER_VIEW_TYPE_MONTH: "Month",
  SCHEDULER_VIEW_TYPE_WEEK: "Week",
  SCHEDULER_FORM_TITLE_LABEL: "Title",
  SCHEDULER_FORM_DESCRIPTION_LABEL: "Description",
  SCHEDULER_FORM_START_LABEL: "Start",
  SCHEDULER_FORM_END_LABEL: "End",
  SCHEDULER_FORM_TYPES_LABEL: "Appointment type",
  SCHEDULER_FORM_TITLE_ERROR_REQUIRED: "Title is required",
  SCHEDULER_FORM_TITLE_ERROR_MAX_LENGTH:
    "Maximum field length is: {{max_length}}",
  SCHEDULER_FORM_DESCRIPTION_ERROR_MAX_LENGTH:
    "Maximum field length is: {{max_length}}",
  SCHEDULER_DIALOG_TITLE: "Make appointment",
  SCHEDULER_FORM_NURSE_ERROR_REQUIRED: "Nurse is required",
  SCHEDULER_NO_COORDINATION_TYPES_WARNING: "There are no active coordination types in the system. They are necessary to use the agenda.",
  SCHEDULER_AGENDA_REPORT_DOWNLOAD: "Download today's report",
  SCHEDULER_AGENDA_EMPTY: "No appointments for today",
  SCHEDULER_AGENDA_CLINICAL_DATA_MAX_LENGTH: "Clinical data can have up to {{max_length}} characters",
  SCHEDULER_AGENDA_CLINICAL_DATA_LABEL: "Clinical data",
  SCHEDULER_AGENDA_DETAILS_MAX_LENGTH: "Details can have up to {{max_length}} characters",
  SCHEDULER_AGENDA_DETAILS_LABEL: "Details",
  APPOINTMENT_SECTOR_REQUIRED: "Required citation sector",
  COORDINATION_EXTRACTION: "Extraction Coordination",
  COORDINATION_EXTRACTION_REQUIRED: "Extraction coordination is required",
  AGENDA_STATUS: 'Status',
  AGENDA_STATUS_REQUIRED: 'Status is required',
  AGENDA_REASON_FOR_CANCELLATION: 'Reason for cancellation',
  AGENDA_REASON_FOR_CANCELLATION_MAX_LENGTH: "Reason for cancellation can have up to {{max_length}} characters",
  AGENDA_REASON_FOR_CANCELLATION_REQUIRED: "Reason for cancellation is required",
  AGENDA_INVALID_HOLDERS: "Invalid Holders",
  AGENDA_REQUIRED_HOLDERS: "Holders are required",
  AGENDA_HOLDER_VALIDATION_STATUS: "Valid",
  AGENDA_NEW: "New appointment",
  AGENDA_SKIP_AND_GO_BACK: 'Skip and return to Calendar',
  AGENDA_GO_BACK_TO_DETAILS: "Back to detail",

  ADD_ATTACHMENT: "New attachment",
  PDF_LABEL: "PDF file",
  EXCEL_LABEL: "Excel file",
  WORD_LABEL: "Word file",
  PPT_LABEL: "PowerPoint file",
  XML_LABEL: "XML file",
  TXT_LABEL: "Text file",
  IMAGE_LABEL: "Image",
  FILE_LABEL: "File",
  DROP_FILE_LABEL: "Click here or drag the files to be uploaded",
  DROP_FILE_LABEL_ACTIVE: "Drop files",
  DROP_FILE_ERROR_MESSAGE:
    "An error occurred while processing the selected file",
  DROP_FILE_MAX_FILES_EXCEED_ERROR_MESSAGE:
    "You can only upload 3 files at a time",
  DROP_FILE_MAX_FILES_EXCEED_GROUP_ERROR_MESSAGE:
    "You can only upload one file for group assignment",
  DROP_FILES_SUCCESS_MESSAGE: "Files uploaded successfully",
  DROP_FILE_SUCCESS_MESSAGE: "File uploaded successfully",
  DROP_FILE_EMPTY_LIST: "No files selected",
  DROP_FILE_EMPTY: "No file selected",
  FILE_ACCEPTED: "File accepted",
  FILE_SIZE_EXCEED: "The file exceeds 10 MB",
  FILE_PICTURE_SIZE_EXCEED: "The picture exceeds 10 MB",
  FILE_FOOTPRINT_1_SIZE_EXCEED: "The footprint 1 exceeds 10 MB",
  FILE_FOOTPRINT_2_SIZE_EXCEED: "The footprint 2 exceeds 10 MB",
  FILE_SIZE_EXCEED_MESSAGE: "A file exceeds 10 MB",
  FILE_NAME_DUPLICATED: "Duplicate file name",
  SELECT_FILE: "Select file",
  STAGE_DUPLICATED: "Duplicate stage",
  INDIVIDUAL_DUPLICATED: "The individual is already in the paternity study",
  STUDIES_EMPTY_LIST: "No studies selected",
  CLINICAL_ANALYSIS_EMPTY_LIST: "No analysis selected",
  PROSPECTS_EMPTY_LIST: "No prospects selected",
  EMPTY_TASKS: "No assigned tasks",
  WAITING_FOR_DATA_IMPORT: "Waiting for data import",
  //! Labels para referencias
  REFERENCE_SUCCESS: "More than 5 days",
  REFERENCE_WARNING: "Between 3 and 4 days",
  REFERENCE_DANGER: "Less than 2 days",
  REFERENCE_IMPORT_SUCCESS: "Ready to process",
  REFERENCE_IMPORT_WARNING: "Already has result",
  REFERENCE_IMPORT_DANGER: "Not found",
  REFERENCE_IMPORT_INCORRECT: "Missing data",
  REFERENCE_IMPORT_PROFILES_SUCCESS: "Ready to process",
  REFERENCE_IMPORT_PROFILES_WARNING:
    "You already have an assigned genetic profile",
  REFERENCE_IMPORT_PROFILES_DANGER: "The individual was not found",
  IMPORT_PROFILES_MESSAGE:
    "Only the profiles of existing individuals will be associated",

  ANALYZES_RESULTS_PROCESS: "A total of {{value}} analyzes will be updated",
  ANALYZES_PROCESS: "Will a total of {{value}} clinical analysis be added",
  PROSPECTS_PROCESS: "Will a total of {{value}} prospects be added",
  NOTHING_PROCESS: "Nothing to process",
  GENETIC_PROFILES_PROCESS: "A total of {{value}} profiles will be added",

  INSTRUCTION_ENTER_TO_ADD: "Press ENTER to add",
  INCORRECT_EMAIL_FORMAT: "Incorrect email format",

  INDIVIDUAL_NOT_FOUND: "No individual found",
  NO_VISITS_THAT_RANGE: "No visits for that date range",
  DENIED_BY_ADMIN: "Access denied by administrator",

  METHOD_NOT_IMPLEMENTED: "Method not implemented",
  DEFAULT_MESSAGE_ERROR: "An error has occurred, please try again later",
  LANGUAGE: "Language",
  PT: "Portuguese",
  ES: "Spanish",
  EN: "English",
  LOADING: "Loading",
  PENDING_CHANGES_ACTION: "There are unsaved changes",
  PENDING_CHANGES: "There are unsaved changes"
};
